import makeStyles from '@mui/styles/makeStyles';
import { PDFObject } from 'react-pdfobject';
import { Button, Paper, Typography, type Theme } from '@mui/material';

const useStyles = makeStyles<Theme>((theme) => ({
  pdfWrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 9999,
  },
  pdfObject: {
    bottom: 0,
    position: 'absolute',
    right: 0,
    left: 0,
    top: '48px',
  },
  pdfCloseBar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    backgroundColor: 'rgb(50, 54, 57)',
    color: 'rgb(241, 241, 241)',
  },
  logoImage: {
    width: 35,
    marginRight: theme.spacing(1),
  },
  logoText: {
    fontSize: 18,
  },
}));

interface Props {
  objectUrl: string;
  onClose: () => void;
}

export const PDFView = (props: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.pdfWrapper}>
      <Paper className={classes.pdfCloseBar} square>
        {/* Invisible item for space-between} */}
        <div className='flex-1' />
        <div className='flex justify-center items-center'>
          <Typography color='inherit' component='span' className={classes.logoText}>
            PDF Viewer
          </Typography>
        </div>
        <div className='flex flex-1 items-center justify-end'>
          <Button onClick={props.onClose} color='inherit'>
            Close
          </Button>
        </div>
      </Paper>
      <PDFObject containerProps={{ className: classes.pdfObject }} url={props.objectUrl} />
    </div>
  );
};
